import { getConfiguration } from "./configuration";

export function roundForCurrency(amount) {
	const conf = getConfiguration();
	const coinRoundMode = conf.cs.crm;
	const nDec = conf.cs.nd;
	if(conf.nas && coinRoundMode != 0) {
		if(coinRoundMode === 1) {
			const minimumCoinAmount = conf.cs.imu;
			let minus = amount;
			let maior = amount;
			while((minus % minimumCoinAmount != 0) && (minus % minimumCoinAmount != minus)) {
				minus --;
			}
			
			while((maior % minimumCoinAmount != 0) && (maior % minimumCoinAmount != maior)) {
				maior ++;
			}
			
			if (minus == 0 && maior == 0) {
				return amount;
			}
			if (minus == 0 && maior > 0) {
				return maior;
			}
			if (minus > 0 && maior == 0) {
				return minus;
			}
			
			if (amount - minus >= maior - amount) {
				return maior;
			}
			else{
				return minus;
			}		
		}
		else if(coinRoundMode === 2) {
			return Math.trunc(amount);
		}
	}
	else {
		// truncate to the nDec decimal part
		const parts = (parseFloat(amount) + "").split('.');
		const natural = parts[0];
		let decimal = parts[1];
		if(!decimal) {
			decimal = "00";
		}
		if(nDec === 0) {
			return parseFloat(natural);
		}
		if(decimal) {
			return parseFloat(natural + "." + decimal.substring(0,nDec));	
		}
	}
}
